import React from 'react'
import Link from 'next/link'
import type { TopicTagFragment } from '../../../.graphql/generated-types'

export interface TopicTagProps {
  data: TopicTagFragment
}

export function TopicTag({ data }: TopicTagProps) {
  const slug = data.slug ?? ''
  const name = data.name ?? ''
  const href = `/topics/${slug}`

  return (
    <li>
      <Link
        href={href}
        className="inline-block py-1 pr-2 text-center text-sm text-blog-purply-pink-300"
      >
        {name}
      </Link>
    </li>
  )
}
